import { node } from "prop-types";
import { useMemo } from "react";

import styled from "styled-components";

import { useIsLoggedIn } from "Flocknote/stateHooks";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";
import {
  ACTIVE_CONTENT_PADDING,
  LOGIN_CONTENT_PADDING,
  TOOLBAR_PADDING_X,
} from "CrossFeatureComponents/MemberToolbar/styleConstants";

const ActiveContentWrapper = ({ children }) => {
  const { activeContentKey } = useMemberToobarContext();

  const isLoggedIn = useIsLoggedIn();

  const isUserContent = useMemo(
    () => activeContentKey !== "nothing" && activeContentKey !== "login",
    [activeContentKey]
  );

  const isLoginContent = useMemo(
    () => activeContentKey === "login",
    [activeContentKey]
  );

  const paddingY = useMemo(() => {
    if (isUserContent) return ACTIVE_CONTENT_PADDING;
    if (isLoginContent) return LOGIN_CONTENT_PADDING;
    return 0;
  }, [isLoginContent, isUserContent]);

  const paddingX = useMemo(() => {
    if (!isLoggedIn) return LOGIN_CONTENT_PADDING + TOOLBAR_PADDING_X;
    return ACTIVE_CONTENT_PADDING + 4 + TOOLBAR_PADDING_X;
  }, [isLoggedIn]);

  return (
    <Wrapper $paddingX={paddingX} $paddingY={paddingY}>
      {children}
    </Wrapper>
  );
};

ActiveContentWrapper.propTypes = { children: node };

const Wrapper = styled.div`
  position: relative;
  padding: ${({ $paddingY, $paddingX }) =>
    `${$paddingY}px ${$paddingX}px 0 ${$paddingX}px`};
  transition: padding 300ms ease-in-out;
`;

export default ActiveContentWrapper;
